import { Button } from '@synergy-marine-group/synergy-ui';
import React from 'react';
import Modal from 'react-responsive-modal';
import { deleteModalStyles } from './styles';

const ConfirmDelete = ({ modal, setModal, handleDelete, handleCancel, subMessage, message }) => {
  const cancelFunction = () => {
    if (handleCancel) {
      handleCancel();
    } else {
      setModal(false);
    }
  };
  return (
    <Modal
    open={modal}
    onClose={() => setModal(false)}
    closeOnOverlayClick={false}
    center
    showCloseIcon={false}
    styles={deleteModalStyles}
    >
      <div className="w-auto py-8 px-8 font-muli">
        <div className="align-middle align-center text-center">
          <h2 className="uppercase text-center pb-8 font-montserrat font-bold">
Confirm
{' '}
{message}
          </h2>
          {subMessage && <div className="font-normal pb-8 w-80 ">{subMessage}</div>}
          <div className="font-normal pb-8">
Are you sure you want to
{' '}
{message}
{' '}
?
          </div>
          <div className="flex justify-between">
            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={cancelFunction}
              size="large"
              variant="outlined"
              rounded
            >
              Cancel
            </Button>

            <Button
              className="max-w-none font-montserrat text-gray-500 uppercase text-sm"
              onClick={handleDelete}
              size="large"
              variant=" filled"
              rounded
            >
              {message}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmDelete;
